<template>
    <div class="paper-detail">
        <div v-if="isDEV && (!paper.pub_year)">
<!--            <PaperWaitSteps/>sdfsdf-->
<!--            <PaperVideoSteps :step="step"/>-->
<!--            <a-tag color="orange" size="large" style="font-size: 16px;padding: 6px 8px">重要信息</a-tag>-->
        </div>
        <a-spin :spinning="loading">
            <a-row :gutter="16">
                <a-col :sm="12" :xs="24">
                    <div class="content">
                        <div v-if="loading" style="padding: 200px;"></div>
                        <div  v-else>
                            <div>
                                <div v-if="isPhone">
                                    <a-affix>
                                        <div style="margin-bottom: 7px; margin-top: 3px">
                                            <span class="top-icon">
                                                <RollBack height="18px"/>
                                            </span>
                                            <a-dropdown>
                                                <span class="top-icon" style="float: right; font-size: 14px">
                                                    <ShareAltOutlined/>
                                                </span>
                                                <template #overlay>
                                                    <a-menu>
                                                        <a-menu-item>
                                                            <a-typography-text :copyable="{ text: href }">
                                                                分享链接
                                                            </a-typography-text>
                                                        </a-menu-item>
                                                        <a-menu-item @click="()=> openQRCode = true">
                                                            分享图片
                                                        </a-menu-item>
                                                    </a-menu>
                                                </template>
                                            </a-dropdown>
                                        </div>
                                    </a-affix>
                                </div>
                                <h1 style="font-size: 22px; font-weight: 600;padding: 0 10px;">
                                    <span @click="goToPubmed" style="cursor: pointer">
                                        {{paper.title_cn}}
                                    </span>
                                    &nbsp;
                                    <span v-if="!isPhone">
                                        <a-dropdown>
                                        <a @click.prevent><ShareAltOutlined/></a>
                                        <template #overlay>
                                            <a-menu>
                                                <a-menu-item>
                                                    <a-typography-text :copyable="{ text: href }">
                                                        分享链接
                                                    </a-typography-text>
                                                </a-menu-item>
                                                <a-menu-item @click="()=> openQRCode = true">
                                                    分享图片
                                                </a-menu-item>
                                            </a-menu>
                                        </template>
                                    </a-dropdown>
                                    </span>
                                </h1>
                            </div>
                            <div class="auto-wrap"
                                 style="line-height: 24px; text-align: justify"
                            >
                                <div>
                                    <div class="content1" style="padding-top: 0; padding-bottom: 0;margin-bottom: 0">
                                        <div>
                                            <span class="paper-gray-text">
                                            <i v-if="paper.journal_title !=='NA'">{{paper.journal_title}}</i>
                                            <span v-if="paper.pub_year">.{{paper.pub_year}}</span>
                                        </span>
                                        </div>
                                        <p style="line-height: 24px;font-size: 14px">
                                            <a-tag color="#1281FF" v-if="paper.article_type">{{paper.article_type}}</a-tag>
                                            <span style="color: #666" v-if="paper.summary_brief">
                                                <MoreORLess
                                                    :text="paper.summary_brief"
                                                    text1="本研究开发了LyMOI平台，结合深度学习和语言模型推理，实现组学数据结合深度学习和语言模型推理，实现组学数据的生物学机制解释，并发现双硫仑与CTSL抑制剂联合使用可有效抑制肿瘤生长。"
                                                    :len="72" title="" line-height="24"
                                                    more-text="展开"
                                                    less-text="收起"
                                                    :no-icon="true"
                                                    tip-size="14"
                                                />
                                                </span>
                                            <span  v-if="paper.jif !=='NA'" style="color:#C00000; float: right">
                                                [{{paper.jif}}]
                                            </span>
                                        </p>
                                        <div v-if="isPhone">
                                            <p class="auto-wrap">
                                                <AuthorOrganization title="作者" extra-title="单位" :text="paper.authors" :extra="paper.organization">
                                                    <template #extra1>
                                                        <show-all title="" :text="paper.organization" :initLen="1"/>
                                                    </template>
                                                </AuthorOrganization>
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p class="auto-wrap">
                                                <show-all title="作者" :text="paper.authors"/>
                                            </p>
                                            <p>
                                                <show-all title="单位" :text="paper.organization" :initLen="1"/>
                                            </p>
                                        </div>

                                        <div>
                                            <MoreORLess
                                                    :text="paper.abstract_cn"
                                                    :len="220" title="摘要：" line-height="28"
                                                    more-text="展开"
                                                    less-text="收起"
                                                    :no-icon="true"
                                            />
                                        </div>
                                        <!--            <simple-code :data="paper.abstract_cn" :len="100" :no-tip="true"/>-->
                                        <!--             {{paper.abstract_cn}}-->
<!--                                        <p class="ai-title" style="margin-top: 20px"><i>AI</i>深度解读</p>-->
                                        <div v-if="!isPhone">
                                            <template v-for="(aiItem, index) in aiItems" :key="index">
                                                <a-tag  style="font-size: 16px;padding: 6px 8px;cursor: pointer" color="#f50" @click="()=>showModal(aiItem.title, paper[aiItem.key])">{{aiItem.title}}</a-tag>
                                            </template>
                                        </div>
                                    </div>

                                    <!--                                    <div class="content1">-->
                                    <!--                                        <p class="ai-title"><i>AI</i>导读音频</p>-->
                                    <!--                                        <pubmed-media cn="音频" media="audio" :progress="progress" :status="paper.audio_status" :paper-no="paper_no" :url="paper.audio_url"/>-->
                                    <!--                                    </div>-->
                                    <div v-if="isPhone">
<!--                                        <a-switch checked-children="视频讲解" un-checked-children="全文拆解" v-model:checked="checked1" />-->
                                        <div class="v-tab">
                                            <span :class="'tab-left ' + (checked1? 'active-tab': '')" @click="toggleTab">视频讲解</span>
                                            <span :class="'tab-right ' + (checked1? '': 'active-tab')" @click="toggleTab">全文拆解</span>
                                        </div>
                                        <div class="content1">
                                            <div v-if="checked1">
                                                <div>
                                                    <p class="ai-title">
                                                        <template v-if="paper?.video_parse_info?.step > 0 && (!showVideo)">
                                                            <div style="float: right">
                                                                <PaperVideoSteps :step="paper?.video_parse_info?.step" :show-video="showVideo"/>
                                                            </div>
                                                        </template>
                                                    </p>
                                                    <template v-if="showVideo">
                                                        <pubmed-media cn="视频" media="video" :progress="progress" :status="paper.video_status" :paper-no="paper_no" :url="paper.video_url"/>
                                                    </template>
                                                    <small v-else-if="paper?.video_parse_info?.step < 0">
                                                        AI视频生成失败
                                                    </small>
                                                    <template v-else-if="paper?.video_parse_info?.step === 0">
                                                        <div style="padding: 160px 30px">
                                                            <paper-wait-steps/>
                                                        </div>
                                                        <p style="text-align: center">
                                                            <small>
                                                                <a-space>
                                                                    目前视频生成请求较多，您的任务正在排队处理<LoadingComponent/>
                                                                </a-space>
                                                            </small>
                                                        </p>
                                                    </template>
                                                    <template v-else-if="paper?.video_parse_info?.step < 4">
                                                        <pdf-img  v-if="Array.isArray(paper?.video_parse_info?.pdf_page)" :data="paper.video_parse_info.pdf_page"/>
                                                        <p style="text-align: center">
                                                            <small v-if="paper?.video_parse_info?.step <= 2">
                                                                <a-space>
                                                                    正在进行课件生成，预计还需2～4分钟生成AI视频<LoadingComponent/>
                                                                </a-space>
                                                            </small>
                                                        </p>
                                                    </template>

                                                    <template v-else-if="paper?.video_parse_info?.step === 4">
                                                        <pdf-ppt  v-if="Array.isArray(paper?.video_parse_info?.ppt_page)" :data="paper.video_parse_info.ppt_page"/>
                                                        <p style="text-align: center">
                                                            <small>
                                                                <a-space>
                                                                    课件已生成，正在制作AI视频，预计还需1～3分钟完成<LoadingComponent/>
                                                                </a-space>
                                                            </small>
                                                        </p>
                                                    </template>
                                                    <small v-else>
                                                        {{'正在生成AI视频，预计需要5分钟...'}}
                                                    </small>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <a-collapse :bordered="false" class="ant-collapse-blue-arrow">
                                                    <template #expandIcon="{ isActive }">
                                                        <right-outlined class="paper-primary-text" :rotate="isActive ? 90 : 0" />
                                                    </template>

                                                    <template v-for="(aiItem, index) in aiItems" :key="index">
                                                        <a-collapse-panel>
                                                            <template #header>
                                                                <span class="paper-primary-text" style="font-size: 18px;">{{aiItem.title}}</span>
                                                            </template>
                                                            <div class="gpt-font">
                                                                <simple-code :data="paper[aiItem.key]" :len="100" :no-tip="true"/>
                                                            </div>
                                                        </a-collapse-panel>
                                                    </template>
                                                </a-collapse>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="content1">
                                        <p class="ai-title">
                                            <i>AI</i>讲解视频
                                            <template v-if="paper?.video_parse_info?.step > 0 && (!showVideo)">
                                                <div style="float: right">
                                                    <PaperVideoSteps :step="paper?.video_parse_info?.step" :show-video="showVideo"/>
                                                </div>
                                            </template>
                                        </p>
                                        <template v-if="showVideo">
                                            <pubmed-media cn="视频" media="video" :progress="progress" :status="paper.video_status" :paper-no="paper_no" :url="paper.video_url"/>
                                        </template>
                                        <small v-else-if="paper?.video_parse_info?.step < 0">
                                            AI视频生成失败
                                        </small>
                                        <template v-else-if="paper?.video_parse_info?.step === 0">
                                            <div style="padding: 160px 30px">
                                                <paper-wait-steps/>
                                            </div>
                                            <p style="text-align: center">
                                                <small>
                                                    <a-space>
                                                        目前视频生成请求较多，您的任务正在排队处理<LoadingComponent/>
                                                    </a-space>
                                                </small>
                                            </p>
                                        </template>
                                        <template v-else-if="paper?.video_parse_info?.step < 4">
                                            <pdf-img  v-if="Array.isArray(paper?.video_parse_info?.pdf_page)" :data="paper.video_parse_info.pdf_page"/>
                                            <p style="text-align: center">
                                                <small v-if="paper?.video_parse_info?.step <= 2">
                                                    <a-space>
                                                        正在进行课件生成，预计还需2～4分钟生成AI视频<LoadingComponent/>
                                                    </a-space>
                                                </small>
                                            </p>
                                        </template>

                                        <template v-else-if="paper?.video_parse_info?.step === 4">
                                            <pdf-ppt  v-if="Array.isArray(paper?.video_parse_info?.ppt_page)" :data="paper.video_parse_info.ppt_page"/>
                                            <p style="text-align: center">
                                                <small>
                                                    <a-space>
                                                        课件已生成，正在制作AI视频，预计还需1～3分钟完成<LoadingComponent/>
                                                    </a-space>
                                                </small>
                                            </p>
                                        </template>
                                        <small v-else>
                                            {{'正在生成AI视频，预计需要5分钟...'}}
                                        </small>
                                    </div>
                                </div>
                                <div v-if="account" class="content1">
                                    <paper-chat
                                            :embedding="paper.embedding"
                                            :paper_no="paper.paper_no"
                                            :handle-search="handleSearchText"
                                            :handle-page="handlePageJump"
                                            :handle-minus="handleMinus"
                                            :chatable="paper.status >= 4"
                                    />
                                </div>

                                <div v-else style="border-radius: 5px; border: 1px dashed #eee; padding: 50px; text-align: center;">
                                    <span><a href="/login" class="paper-primary-text">登录</a>后开启进阶体验：上传文献、视频讲解、交互问答，让科研更高效。</span>
                                </div>
                            </div>
                        </div>

                        <a-modal v-model:open="open" :title="modalTitle" @ok="()=>open = false" width="800px">
                            <div style="margin-bottom: 20px;max-height: 420px; overflow-y: auto; padding-right: 5px;" class="gpt-font">
                                <simple-code :data="modalData" :len="100" :no-tip="true"/>
                            </div>
                        </a-modal>
                        <a-modal v-model:open="openQRCode" class="modal-width" :footer="null">
                            <a-row align="bottom" :gutter="8">
                                <a-col span="22">
                                    <div style="background: #F2F2F2; border-radius: 5px; padding: 15px 10px" id="card">

                                        <h3 style="line-height: 24px;">
                                            {{paper.title_cn}}
                                        </h3>
                                        <p>
                                            <span v-if="paper.journal_title !=='NA'">{{paper.journal_title}}</span>
                                        </p>
                                        <div style="border: 1px solid #efefef; border-radius: 5px; padding: 10px">
                                            {{paper.summary_brief}}
                                        </div>
                                        <a-row style="margin-top: 20px">
                                            <a-col span="8">
                                                <paper-qrcode :href="href"/>
                                            </a-col>
                                            <a-col span="16" style="text-align: right;">
                                                <a href="/">
                                                    <b style="font-size: 32px">VIPaper</b>
                                                </a>
                                                <p><small>扫描二维码，阅读完整图文</small></p>
                                            </a-col>
                                        </a-row>
                                    </div>
                                </a-col>
                                <a-col span="2">
                                    <p>
                            <span class="circle">
                                <CopyOutlined @click="copyImg"/>
                            </span>
                                    </p>
                                    <p>
                            <span class="circle">
                                <DownloadOutlined @click="generateImg"/>
                            </span>
                                    </p>
                                </a-col>
                            </a-row>
                            <img v-if="imgData" :src="'data:image/png;base64,' + imgData" alt="" width="100" id="imageElement">
                        </a-modal>
                    </div>
                </a-col>
                <a-col span="12" v-if="!isPhone">
                    <div class="content">

                        <PdfHighlight
                                v-if="paper.pdf_url"
                                ref="pdfViewer1"
                                :pdf-url1="isDEV?'/test2.pdf': paper.pdf_url"
                                :pdf-url=" paper.pdf_url"
                                :active-span="mineruData"
                                :initial-page="1"
                                @page-changed="onPageChanged"
                                @highlight-added="onHighlightAdded"
                                @highlight-removed="onHighlightRemoved"
                        />
                    </div>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>

<script>
    import {ShareAltOutlined, CopyOutlined, DownloadOutlined, RightOutlined} from '@ant-design/icons-vue';
    import {isDEV, get_args} from "../utils/request";
    import {
        post_biogpt_upload_share,
        post_biogpt_subscribe_share_paper,
        post_biogpt_paper_upload_info
    } from "../utils/bioinfo.api";
    import {jy_tip, exportAsImage, downImg, copyImageUrl, copyImageToClipboard} from "../utils/vue.tool";
    import SimpleCode from "../components/SimpleCode";
    import ShowAll from "../components/ShowAll";
    import AuthorOrganization from "../components/AuthorOrganization";
    import PaperChat from "./PaperChat";
    import PdfHighlight from "../components/PdfHighlight";
    import LoadingComponent from "../components/LoadingComponent";
    import PdfPpt from "../components/PdfPpt";
    import PdfImg from "../components/PdfImg";
    import PaperVideoSteps from "../components/PaperVideoSteps";
    import PaperWaitSteps from "../components/PaperWaitSteps";
    import MoreORLess from "../components/MoreORLess";
    import RollBack from "../components/RollBack";
    import PubmedMedia from './PubmedMedia';
    import PaperQrcode from './PaperQrcode';
    // import PaperDetailMobile from "./mobile/PaperDetailMobile";
    import {isLogin, isMobile} from "../utils/llm.tools";
    export default {
        name: "PaperDetail",
        components: {
            // PaperDetailMobile,
            MoreORLess,
            RightOutlined,
            ShowAll,
            AuthorOrganization,
            SimpleCode,
            PubmedMedia,
            PaperQrcode,
            PaperChat,
            ShareAltOutlined,
            CopyOutlined, DownloadOutlined,
            PdfHighlight,
            PdfImg,
            PdfPpt,
            LoadingComponent,
            PaperVideoSteps,
            PaperWaitSteps,
            RollBack
        },
        data(){
            let {upload_no, keyword, paper_no, share_code} = get_args();
            return {
                isDEV,
                step: 0,

                checked1: true,
                loading: true,
                openQRCode: false,
                mineruData: {},
                pubmed: {keyword: keyword || ''},
                upload_no: Number(upload_no),
                paper_no: Number(paper_no),
                share_code: share_code,
                account: isLogin(),
                href: window.location.href,
                progress: 0,
                height: 60,
                showVideo: false,
                paper: {
                    // videoData: 'http://drai.cn/video/demo/20250717_102123_s41586-025-09227-0.mp4',
                    // audioData: 'http://drai.cn/audio/demo/20250717_102123_s41586-025-09227-0.wav'
                },
                open: false,
                modalTitle: '',
                modalData: '',
                imgData: '',
                aiItems: [
                    {title: '要点总结', key: 'summary'},
                    {title: '研究方法', key: 'research_method'},
                    {title: '关键创新点', key: 'key_innovation'},
                    {title: '局限性', key: 'limitations'},
                ],
                searchKeyword: '',
                pageNumber: 1,
                isViewerLoaded: false,
                isPhone: isMobile()
            }
        },
        created(){
            this.getPaperDetail();
            let {paper_no, upload_no, share_code} = this;
            if(!share_code){
                post_biogpt_upload_share({upload_no, paper_no}, (res)=>{
                    if(res?.data?.share_code) this.href += '&share_code=' + (res.data.share_code)
                })
            }
            if(isDEV){
                let timer = setInterval(()=>{
                    if(this.step > 5){
                        clearInterval(timer);
                        return;
                    }
                    this.step += 1;
                }, 2000)
            }
        },
        methods: {
            getPaperDetail(){
                let {paper_no, share_code, upload_no} = this;
                if(upload_no) {
                    if(share_code)post_biogpt_subscribe_share_paper({share_code, paper_no, upload_no}, this.handleDetailRes);
                    else post_biogpt_paper_upload_info({paper_no, upload_no}, this.handleDetailRes);
                }
            },
            handleDetailRes(res){
                this.loading = false;
                let {data, message} = res;
                if(data){
                    let {upload_status: newStatus, video_parse_info, embedding} = data;
                    this.paper = {...data};
                    this.progress = newStatus;
                    // let showV = video_parse_info?.step === 4;
                    let showV = (newStatus & 4) === 4;
                    this.showVideo = showV;
                    if(!showV) {
                        console.log('======showVideo======', showV, video_parse_info?.step);
                        setTimeout(()=>{
                            this.getPaperDetail();
                        }, 5000)
                    }else if(embedding === 1){
                        setTimeout(()=>{
                            this.getPaperDetail();
                        }, 5000)
                    }
                } else jy_tip(message);
            },

            showModal(title, data){
                this.open = true;
                this.modalTitle = title;
                this.modalData = data;
            },
            async copyImg3(){
                // generateIm
                let ele = document.getElementById('imageElement');
                if (!ele) return;

                try {
                    // 创建Canvas绘制图片
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = ele.naturalWidth;
                    canvas.height = ele.naturalHeight;
                    ctx.drawImage(ele, 0, 0);

                    // 转换为Blob
                    const blob = await new Promise(resolve =>
                        canvas.toBlob(resolve)
                    );

                    // 写入剪贴板
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            [blob.type]: blob
                        })
                    ]);

                    alert('图片已复制到剪贴板');
                } catch (error) {
                    console.error('复制失败:', error);
                    alert('复制失败: ' + error.message);
                }
            },
            copyImg2(){
                // generateIm
                if(this.imgData) copyImageUrl(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    copyImageUrl(imgData);
                })
            },
            copyImg(){
                // generateIm
                if(this.imgData) copyImageToClipboard(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    copyImageToClipboard(imgData);
                })
            },
            generateImg(){
                // generateIm
                if(this.imgData) downImg(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    downImg(imgData);
                })
            },
            //pdf相关
            onViewerLoaded() {
                this.isViewerLoaded = true;
                // jy_tip('PDF加载完毕', 'success');
            },
            handleSearchText(searchKeyword) {
                searchKeyword = searchKeyword.trim();
                if (searchKeyword) {
                    if (this.isViewerLoaded) {
                        this.$refs.pdfViewer.highlightKeyword(searchKeyword);
                    }
                }

            },
            clearHighlight() {
                // 通过触发一个空搜索来“清除”高亮，但这并非真正清除，只是高亮了空字符串（视觉上无变化）
                // 另一种思路是直接重新加载iframe，但这会丢失当前页面状态
                if (this.isViewerLoaded) {
                    this.$refs.pdfViewer.highlightKeyword('');
                    this.searchKeyword = '';
                }
            },
            handlePageJump(page) {
                this.pageNumber = typeof page === 'string' ? Number(page?.split('-')[0]): page;
                if (this.isViewerLoaded && this.pageNumber) {
                    this.$refs.pdfViewer.jumpToPage(this.pageNumber);
                }
            },
            handleMinus(mineruData) {
                this.mineruData = {...mineruData};
                if (this.$refs.pdfViewer1 && mineruData) {

                    console.log('handleMinus', this.$refs.pdfViewer1.addHighlight);
                    // 添加高亮
                    this.$refs.pdfViewer1.addHighlight( mineruData.page + 1, mineruData);
                }
            },
            goToPubmed(){
                let href = 'https://pubmed.ncbi.nlm.nih.gov/' + this.paper.pmid;
                window.open(href, '_blank')
            },
            toggleTab(){
                this.checked1 = !this.checked1;
            }
        }
    }
</script>

<style scoped>
    .paper-detail {padding: 10px;}
    .top-icon {
        background: #7F7F7F; padding: 2px; border-radius: 16px;color: #FFF
    }
    .height90, .content {
        height: 92vh;
        font-size: 18px!important;
        overflow-y: auto;
    }
    .content {
        background: #FAFAFA;
        border-radius: 10px;
        padding: 1%;
    }
    .content-left{
        padding: 10px 20px;
    }
    .content1{
        background: #FFF;
        border-radius: 8px;
        margin-bottom: 15px;
        padding: 10px;
    }
    .auto-wrap {
        word-wrap: break-word!important; /* 旧版浏览器支持 */
        overflow-wrap: break-word!important; /* 标准属性 */
        word-break: break-all;
        /*white-space: nowrap;不换行*/
    }
    .v-tab{
        margin: 10px 0; padding: 10px 0; background: #EAE8EB; border-radius: 25px; text-align: center
    }
    .active-tab{;
        background: #FFF;
        border-radius: 25px;
    }
    .tab-left, .tab-right{
        padding: 10px 50px;
        font-size: 16px;
    }
    .tab-left{
        /*margin-right: 40px;*/
    }
    .tab-right{
        /*margin-left: 50px*/
    }
    /* 在你的项目的CSS文件中覆盖 */
    .textLayer .highlight {
        background-color: #FEFFE0 !important; /* 红色半透明高亮 */
    }
    .modal-width{
        max-width: 960px;
    }
    .ai-title{
        color: #4472C4; font-size: 18px; font-weight: 500;
    }
    .circle{
        border-radius: 20px;
        display: block;
        background: #eeeeee;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    /*{*/
    /*  xs: '480px',*/
    /*  sm: '576px',*/
    /*  md: '768px',*/
    /*  lg: '992px',*/
    /*  xl: '1200px',*/
    /*  xxl: '1600px',*/
    /*}*/
    /* 当视口宽度小于 600px 时 */
    @media (max-width: 480px) {
        .height90, .content {
            height: 100%;
        }
        .paper-detail {padding: 0;}
        .pubmed-width {
            width: 100%;
            /*border: 1px solid red;*/
            overflow-wrap: break-word!important; /* 标准属性 */
            word-break: break-all;
        }
        .modal-width{
            width: 98%
        }
        .content {
            padding: 0;
        }
        .content-left{
            padding: 0;
        }
    }

    /* 隐藏滚动条 */
    ::-webkit-scrollbar {
        width: 0; /* 设置滚动条宽度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1; /* 设置滚动条轨道背景颜色 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #999; /* 设置滚动条滑块颜色 */
    }

    /* 滚动条滑块悬停状态 */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块悬停状态颜色 */
    }

    .paper-primary-text {
        color: #576B95!important;
    }
    .paper-gray-text {
        color: #767676!important;
    }
    /*CSS代码：*/
    /* src/styles/components/collapse.css */
    .ant-collapse-blue-arrow .ant-collapse-item .ant-collapse-header .ant-collapse-arrow {
        color: #576B95 !important;
        transition: color 0.3s;
    }

    .ant-collapse-blue-arrow .ant-collapse-item .ant-collapse-header:hover .ant-collapse-arrow {
        color: #576B95 !important;
    }

    .ant-collapse-blue-arrow .ant-collapse-item-active .ant-collapse-header .ant-collapse-arrow {
        color: #576B95 !important;
    }
</style>